import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Card, CardContent } from './ui/Card';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const revealRef = useScrollReveal();
  const testimonials = [{
    quote: 'Spolupráca s Larsen Evans zmenila náš pohľad na to, čo je možné. Za 3 mesiace sme mali funkčnú AI platformu.',
    name: 'Ing. Martin Kováč',
    role: 'CTO',
    company: 'DataFlow SK',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Ich PWA riešenie nám ušetrilo 40% nákladov na vývoj mobilnej aplikácie. Kvalita je na úrovni natívnych appiek.',
    name: 'Mgr. Zuzana Horváthová',
    role: 'CEO',
    company: 'MedTech Solutions',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Gemini embeddings integrované do nášho systému zvýšili presnosť vyhľadávania o 85%. Neuveriteľné výsledky.',
    name: 'Bc. Peter Novák',
    role: 'Head of AI',
    company: 'LogiSmart',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=face'
  }];
  return <section ref={revealRef} className="py-36 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-455">
      <div className="reveal text-center mb-28" data-id="element-456">
        <p className="text-xs font-semibold tracking-[0.2em] text-apple-gray uppercase mb-6" data-id="element-457">
          REFERENCIE
        </p>
        <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight text-apple-black mb-6" data-id="element-458">
          Čo Hovoria Naši Klienti
        </h2>
        <p className="text-xl text-apple-gray font-light max-w-2xl mx-auto leading-relaxed" data-id="element-459">
          Výsledky hovoria za všetko. Prečítajte si skúsenosti firiem, ktoré už
          využívajú naše PWA a AI riešenia.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-460">
        {testimonials.map((testimonial, index) => <div key={index} className={`reveal reveal-delay-${index + 1}`} data-id="element-461">
            <Card className="h-full border-gray-100 rounded-3xl bg-white/80 backdrop-blur-sm shadow-sm card-hover-premium overflow-hidden" data-id="element-462">
              <CardContent className="p-10 flex flex-col h-full relative" data-id="element-463">
                {/* Decorative quote icon */}
                <QuoteIcon className="w-10 h-10 text-apple-blue/10 absolute top-6 right-6" data-id="element-464" />

                <div className="flex gap-1 mb-6" data-id="element-465">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current text-amber-400" data-id="element-466" />)}
                </div>

                <p className="text-apple-black text-lg leading-relaxed font-light mb-8 flex-grow relative" data-id="element-467">
                  <span className="text-3xl font-bold text-apple-blue/20 leading-none mr-1" data-id="element-468">
                    "
                  </span>
                  {testimonial.quote}
                  <span className="text-3xl font-bold text-apple-blue/20 leading-none ml-1" data-id="element-469">
                    "
                  </span>
                </p>

                <div className="flex items-center gap-4 mt-auto pt-6 border-t border-gray-100" data-id="element-470">
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-md" data-id="element-471" />
                  <div data-id="element-472">
                    <h4 className="font-bold text-apple-black text-sm" data-id="element-473">
                      {testimonial.name}
                    </h4>
                    <p className="text-apple-gray text-xs font-light" data-id="element-474">
                      {testimonial.role}, {testimonial.company}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>)}
      </div>
    </section>;
}